"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @class DemandTemplates
 * @classdesc Handles templates for demands sent to debtors
 */
var DemandTemplates = /** @class */ (function () {
    function DemandTemplates(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof DemandTemplates
         * @returns {ISuccessfulIndexDemandTemplateRequest} Returns a message and an array of information on all demand templates
         * @description Returns an index of information on all demand templates.
         */
        this.index = function () {
            return _this.recover.request("/demand_templates", "GET", null, null);
        };
        /**
         *
         *
         * @memberof DemandTemplates
         * @returns {ISuccessfulGetDemandTemplateRequest} Returns a HTML version of the demand letter
         * @property {Blob}
         */
        this.create = function (newDemand) {
            return _this.recover.request("/demand_templates", "POST", newDemand, null);
        };
        /**
         *
         *
         * @memberof DemandTemplates
         */
        this.single = function (id) {
            return _this.recover.request("/demand_templates/" + id, "GET", null, null);
        };
        /**
         *
         *
         * @memberof DemandTemplates
         */
        this.edit = function (id, editDemand) {
            return _this.recover.request("/demand_templates/" + id, "PUT", editDemand, null);
        };
    }
    return DemandTemplates;
}());
exports.default = DemandTemplates;
